/*
 * Copyright (c) 2023 CalAmp Corp. All Rights Reserved
 */
import React from 'react';
import {dlsColor} from '../theme/theme';
import {IconSize} from '../types/types';
import useIconDLS from './useIconDLS';

export interface OpenModalIconProps {
  color?: string;
  size?: IconSize | number;
}

/*
 * Defines the Design Language System (DLS) Open Modal Icon component.
 */
export const OpenModalIcon = ({size = IconSize.small, color = dlsColor('grey3')}: OpenModalIconProps) => {
  const {iconSize} = useIconDLS({size});
  return (
    <svg width={iconSize} height={iconSize} viewBox="0 0 16 16" fill="none">
      <path d="M14.4856 6.04597V11.2971C14.4856 11.5733 14.2617 11.7971 13.9856 11.7971H5.21728C4.94114 11.7971 4.71729 11.5733 4.71729 11.2971V2.52881C4.71729 2.25267 4.94114 2.02881 5.21729 2.02881H10.0361" stroke={color} strokeWidth="1.5" strokeMiterlimit="10"/>
      <path d="M11.5329 12.1523V14.7502C11.5329 15.0263 11.309 15.2502 11.0329 15.2502H1.5C1.22386 15.2502 1 15.0263 1 14.7502V5.21729C1 4.94114 1.22386 4.71729 1.5 4.71729H4.71749" stroke={color} strokeWidth="1.5"/>
      <path d="M14.9993 4.09791V1L11.9146 1.16066" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M15.0001 1L10.373 5.62709" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  );
};
